var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dollar-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg dollar",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.45,14.54a38.15,38.15,0,0,0-3.91-1.78,8.4,8.4,0,0,1-2.15-1.2,1.86,1.86,0,0,1,.46-3.32A3.58,3.58,0,0,1,16.17,8a9.93,9.93,0,0,1,4.94,1c.78.38,1,.26,1.3-.55s.51-1.73.77-2.6a.91.91,0,0,0-.59-1.21,12.47,12.47,0,0,0-3.12-.93c-1.41-.22-1.41-.22-1.42-1.65,0-2,0-2-2-2h-.88C14.22,0,14.07.19,14,1.14c0,.42,0,.85,0,1.27,0,1.26,0,1.24-1.21,1.68-2.91,1-4.71,3-4.9,6.21-.17,2.81,1.3,4.71,3.6,6.09a41.21,41.21,0,0,0,4.5,2,6.72,6.72,0,0,1,1.64,1,2.25,2.25,0,0,1-.53,3.94,5.39,5.39,0,0,1-2.89.38,12.81,12.81,0,0,1-4.4-1.32c-.82-.42-1.05-.31-1.33.57s-.45,1.53-.66,2.3c-.29,1-.18,1.27.8,1.75a14.11,14.11,0,0,0,4,1.14c1.07.17,1.1.22,1.12,1.33,0,.5,0,1,0,1.51s.31,1,1,1,1.49,0,2.23,0a.84.84,0,0,0,.92-.95c0-.69,0-1.39,0-2.07a1.1,1.1,0,0,1,.94-1.25,7.43,7.43,0,0,0,3.89-2.49A7,7,0,0,0,20.45,14.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.c1fc0a8aed529bdf9e91aadb6d798c2a.svg";
export { ForwardRef as ReactComponent };